module.exports = __webpack_public_path__ + "img/sumarary.88b2bdb0.png";